var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.481 9.08a8.248 8.248 0 004.811 1.54V7.168c-.34 0-.678-.036-1.01-.106v2.716A8.25 8.25 0 0115.47 8.24v7.042a6.38 6.38 0 01-6.382 6.378 6.352 6.352 0 01-3.552-1.079A6.363 6.363 0 0010.1 22.5a6.38 6.38 0 006.381-6.378V9.08zm1.246-3.48a4.808 4.808 0 01-1.246-2.816V2.34h-.958a4.83 4.83 0 002.204 3.26zm-9.96 12.278a2.918 2.918 0 013.209-4.547V9.803a6.438 6.438 0 00-1.01-.058v2.746a2.923 2.923 0 00-3.806 2.78c0 1.14.654 2.127 1.606 2.607z",
    fill: "#FF004F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.471 8.24a8.25 8.25 0 004.811 1.539V7.063a4.83 4.83 0 01-2.554-1.464 4.83 4.83 0 01-2.204-3.26h-2.515v13.783a2.919 2.919 0 01-5.243 1.756 2.917 2.917 0 012.2-5.387V9.745a6.38 6.38 0 00-4.428 10.836A6.353 6.353 0 009.09 21.66a6.38 6.38 0 006.381-6.378V8.24z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.283 7.063V6.33a4.812 4.812 0 01-2.555-.73 4.825 4.825 0 002.555 1.464zM15.524 2.34a4.94 4.94 0 01-.052-.396V1.5h-3.473v13.782a2.918 2.918 0 01-4.232 2.596 2.919 2.919 0 005.243-1.756V2.34h2.514zM9.966 9.745v-.781a6.38 6.38 0 00-7.257 6.318 6.37 6.37 0 002.83 5.3A6.38 6.38 0 019.966 9.745z",
    fill: "#00F2EA"
  })));
}

export default SvgIconTiktok;